import { withInstall } from "@xplus/utils/with-install";
import pagination from "./src/pagination.vue";
export const xPagination = withInstall(pagination);
export default xPagination;
export * from "./src/pagination";
